import axios from 'api/config'

// #goal avoid this request for feature specs to make them more stable and faster
// #approach JS tests to mock this module to allow for selective testing
const currentEnv = process.env.RAILS_ENV || 'development'
const isTest = currentEnv === 'test'

const pushedKeys = new Set()

const pushToDataLayer = (event, payload = {}) => {
  const reset = {}
  pushedKeys.forEach(key => {
    if (!(key in payload)) reset[key] = null
  })
  Object.keys(payload).forEach(key => pushedKeys.add(key))

  window.dataLayer = window.dataLayer || []
  window.dataLayer.push({ ...reset, ...payload, event })
}

export const trackEvent = (event, payload) => {
  if (isTest) {
    return Promise.resolve()
  }

  if (window.posthog) {
    window.posthog.capture(event, payload)
  }

  pushToDataLayer(event, payload)

  return axios.post('/api/analytics', {
    event,
    payload
  })
}
